module.exports = __webpack_public_path__ + "static/img/warning.81204df1.svg";